import { CompletedPondParams, PondFilters } from 'modules/pond/api/types'

export const USER_INFO_KEY = ['user']
export const FARMS_KEY = ['farms']
export const getFarmWeatherKey = (farmId: string) => ['farm-weather', farmId]
export const CATEGORY_KEY = ['category']
export const WAREHOUSE_KEY = ['warehouse']
export const STOCK_KEY = ['stock']
export const STOCK_ID_KEY = ['stock-id']
export const STOCK_HISTORY_KEY = ['stock-history']
export const UNIT_KEY = ['unit']
export const PRODUCT_CATEGORY_KEY = ['product-category']
export const PRODUCT_KEY = ['products']
export const PRODUCT_STOCK_KEY = ['products-stock']
export const CATEGORY_ID_KEY = ['category-id']
export const PRODUCT_HISTORY_ID_KEY = ['product-history-id']
export const PRODUCT_ID_KEY = ['product-id']
export const PRODUCT_V3_KEY = ['products-v3']
export const STOCK_STATISTIC_KEY = ['stock-statistic']
export const PRODUCT_V3_DETAIL_KEY = ['product-v3-detail']
export const STOCKS_V3_KEY = ['stocks-v3']
export const STOCK_HISTORY_V3_KEY = ['stock-history-v3']
export const STOCK_HISTORY_STATISTIC_V3_KEY = ['stock-history-statistic-v3']

export const getFarmReverseGeocode = (farmId: string) => ['farm-reverse-geocode', farmId]
export const MANAGERS_KEY = ['managers']
export const REQUESTED_EMPLOYEE_KEY = ['requested-employee']
export const EMPLOYEES_KEY = ['employees']
export const POND_CARETAKERS = ['pond-caretakers']
export const POND_TYPES_KEY = ['pond-types']
export const FOOD_BRANDS_KEY = ['food-brands']
export const SHRIMP_BRANDS_KEY = ['shrimp-brands']
export const getShrimpTypesKey = (brand: number) => ['shrimp-types', brand]
export const getCycleKey = {
  all: () => ['cycle'],
  list: (pondId?: string) => [...getCycleKey.all(), 'list', pondId],
  byCycleId: (cycleId: string) => [...getCycleKey.all(), 'by-cycle-id', cycleId],
  byFarmByPond: (farmId: string, pondId: string) => [
    ...getCycleKey.all(),
    'by-farm-by-pond',
    farmId,
    pondId,
  ],
}
export const getMealsKey = {
  all: () => ['meals'],
  list: (date: string, cycleId: string) => [...getMealsKey.all(), date, cycleId],
}
export const getMealsByProductKey = {
  all: () => ['meals-by-product'],
  details: (cycleId: string, mealId: number) => [...getMealsByProductKey.all(), cycleId, mealId],
}
export const FOOD_SIZES_KEY = ['food-sizes']
export const FEEDING_TYPES_KEY = ['feeding-types']
export const getFoodLineChartKey = {
  all: () => ['food-line-chart'],
  details: (cycleId: string) => [...getFoodLineChartKey.all(), cycleId],
}
export const getFoodsKey = {
  all: () => ['foods'],
  list: ({
    cycleId,
    date,
    feedingType,
  }: {
    cycleId: string
    date?: Date
    feedingType?: number
  }) => [...getFoodsKey.all(), cycleId, date, feedingType],
}
export const getFoodsByRangeKey = {
  all: () => ['foods-by-range'],
  list: ({
    cycleId,
    startDate,
    endDate,
    feedingType,
  }: {
    cycleId: string
    startDate?: Date
    endDate?: Date
    feedingType?: number
  }) => [...getFoodsByRangeKey.all(), cycleId, startDate, endDate, feedingType],
}

export const getWaterQualityKey = {
  all: () => ['water-quality'],
  list: (cycleId: string, date?: Date | string) => [
    ...getWaterQualityKey.all(),
    'list',
    cycleId,
    date,
  ],
  chart: (cycleId: string) => [...getWaterQualityKey.all(), 'chart', cycleId],
  today: (cycleId: string) => [...getWaterQualityKey.all(), 'today', cycleId],
  byDate: (cycleId: string, date?: Date | string) => [
    ...getWaterQualityKey.all(),
    'by-date',
    cycleId,
    date,
  ],
}

export const getWaterMineralKey = {
  all: () => ['water-mineral'],
  list: (cycleId: string, date?: Date | string) => [
    ...getWaterMineralKey.all(),
    'list',
    cycleId,
    date,
  ],
  chart: (cycleId: string) => [...getWaterMineralKey.all(), 'chart', cycleId],
}

export const getWaterBacteriaKey = {
  all: () => ['water-bacteria'],
  list: (cycleId: string, date?: Date | string) => [
    ...getWaterBacteriaKey.all(),
    'list',
    cycleId,
    date,
  ],
  chart: (cycleId: string) => [...getWaterBacteriaKey.all(), 'chart', cycleId],
}

export const getPondDashboardChartKey = (cycleId: string) => ['pond-dashboard-chart', cycleId]
export const getPondDashboardRevenueChartKey = (cycleId: string) => [
  'pond-dashboard-revenue-chart',
  cycleId,
]
export const getWaterQualityTodayKey = {
  all: () => ['water-quality-today'],
  details: (cycleId: string) => [...getWaterQualityTodayKey.all(), cycleId],
}
export const getWaterMineralChartKey = {
  all: () => ['water-mineral-chart'],
  details: (cycleId: string) => [...getWaterMineralChartKey.all(), cycleId],
}

export const getShrimpMortalityKey = {
  all: () => ['shrimp-mortality'],
  list: (cycleId: string, params: Record<string, unknown>) => [
    ...getShrimpMortalityKey.all(),
    'list',
    cycleId,
    params,
  ],
  chart: (cycleId: string) => [...getShrimpMortalityKey.all(), 'chart', cycleId],
  summaryToday: (cycleId: string) => [...getShrimpMortalityKey.all(), 'summary-today', cycleId],
  recentSize: (cycleId: string, date?: string) => [
    ...getShrimpMortalityKey.all(),
    'recent-size',
    cycleId,
    date,
  ],
  disease: (speciesId: number) => [...getShrimpMortalityKey.all(), 'disease', speciesId],
}

export const getGrowthShrimpChartKey = (cycleId: string) => ['growth-shrimp-chart', cycleId]
export const getGrowthShrimpsKey = (
  cycleId: string,
  date?: Date | string,
  startDate?: Date | string,
  endDate?: Date | string
) => ['growth-shrimps', cycleId, date, startDate, endDate]
export const getGrowthShrimpTodayKey = (cycleId: string) => ['growth-shrimp-today', cycleId]
export const getMedicinesKey = {
  all: () => ['medicines'],
  list: (cycleId: string, date?: Date | string) => [...getMedicinesKey.all(), cycleId, date],
}
export const getMedicinesByRangeKey = {
  all: () => ['medicines-by-range'],
  list: (cycleId: string, startDate?: Date | string, endDate?: Date | string) => [
    ...getMedicinesByRangeKey.all(),
    cycleId,
    startDate,
    endDate,
  ],
}
export const getLatestMedicinePriceKey = {
  all: () => ['medicine-price'],
  details: (name: string) => [...getLatestMedicinePriceKey.all(), name],
}
export const getMedicineNameKey = {
  all: () => ['medicine-names'],
  list: (farmId: string) => [...getMedicineNameKey.all(), farmId],
}
export const getMedicineSummaryTodayKey = {
  all: () => ['medicine-summary-today-names'],
  list: (farmId: string) => [...getMedicineSummaryTodayKey.all(), farmId],
}
export const getMedicinePieChartKey = {
  all: () => ['medicine-pie-chart'],
  details: (cycleId: string) => [...getMedicinePieChartKey.all(), cycleId],
}
export const getLatestFoodPriceKey = (cycleId: string, foodSizeId: number | null) => [
  'food-price',
  cycleId,
  foodSizeId,
]
export const getPondKey = {
  all: () => ['ponds'],
  list: (farmId?: string) => [...getPondKey.all(), 'list', farmId],
  filter: (farmId?: string, pondFilters?: PondFilters) => [
    ...getPondKey.all(),
    'filter',
    farmId,
    pondFilters,
  ],
  filterCount: (farmId?: string) => [...getPondKey.all(), 'filter-count', farmId],
  completed: (farmId?: string, params?: CompletedPondParams) => [
    ...getPondKey.all(),
    'completed',
    farmId,
    params,
  ],
  names: (farmId: string) => [...getPondKey.all(), 'names', farmId],
  details: (cycleId: string) => [...getPondKey.all(), 'details', cycleId],
}
export const getPondDashboardKey = {
  all: () => ['pond-dashboard'],
  overview: (pondId: string, cycleId: string) => [
    ...getPondDashboardKey.all(),
    'overview',
    pondId,
    cycleId,
  ],
  finance: (pondId: string, cycleId: string) => [
    ...getPondDashboardKey.all(),
    'finance',
    pondId,
    cycleId,
  ],
}

export const getCostKey = {
  all: () => ['cost'],
  details: (cycleId: string | null) => [...getCostKey.all(), cycleId],
}
export const UNIT = ['unit']
export const AREA_UNIT = ['areaUnit']

export const getShrimpSalesKey = {
  all: () => ['shrimp-sales'],
  details: (cycleId: string, date?: Date) => [...getShrimpSalesKey.all(), 'details', cycleId, date],
  summary: (cycleId: string) => [...getShrimpSalesKey.all(), 'summary', cycleId],
  latestCategory: (cycleId: string) => [...getShrimpSalesKey.all(), 'latest-category', cycleId],
}

export const getFoodBrandsKey = (speciesId?: number) => ['food-brands', speciesId]
export const LATEST_FOOD_BRAND = ['latest-food-brand']
export const LATEST_FOOD_SIZE = ['latest-food-size']
export const getFoodSizeKey = {
  all: () => ['food-size'],
  list: (foodBrandId: number, proteinId: number, breedId?: number) => [
    ...getFoodSizeKey.all(),
    foodBrandId,
    proteinId,
    breedId,
  ],
}
export const getShrimpPriceKey = (startDate: string, endDate: string, regionId: number | null) => [
  'shrimp-price',
  startDate,
  endDate,
  regionId,
]
export const SPECIES_KEY = ['species']
export const getSpeciesIdKey = (speciesId: number) => ['speciesId', speciesId]
export const getBreedKey = (speciesId: number) => ['breed', speciesId]
export const getBreedBrandKey = (breedId: number) => ['breed-brand', breedId]
export const getBreedProductKey = (breedId: number, speciesId: number) => [
  'breed-product',
  breedId,
  speciesId,
]
export const getBreedNameKey = (speciesId: number, breedId: number) => [
  'breedName',
  speciesId,
  breedId,
]
export const getFeedProgramsKey = () => ['feedPrograms']
export const getFeedProgramIdKey = (feedProgramId: number) => ['feedProgramId', feedProgramId]

export const getProteinKey = (foodbrandId: number, speciesId: number) => [
  'protein',
  foodbrandId,
  speciesId,
]
export const getRecentFoodKey = {
  all: () => ['recent-food'],
  details: (cycleId: string) => [...getRecentFoodKey.all(), cycleId],
}
export const getRecentFoodByProductKey = {
  all: () => ['recent-food-by-product'],
  byCycleId: (cycleId: string) => [...getRecentFoodByProductKey.all(), 'by-cycle-id', cycleId],
}
export const getRecentMedicineKey = {
  all: () => ['recent-medicine'],
  details: (cycleId: string) => [...getRecentMedicineKey.all(), cycleId],
}
export const getMarketIdKey = (marketId: number) => ['marketId', marketId]

export const getMembersKey = {
  all: () => ['members'],
  list: (userId?: string) => [...getMembersKey.all(), userId],
  details: (userId: string) => [...getMembersKey.all(), 'details', userId],
}
export const getRolesKey = (userId?: string) => ['roles', userId]
export const getPresetKey = (userId?: string) => ['preset', userId]
export const getFeaturesKey = (userId?: string) => ['features', userId]
export const getRoleDetailKey = (userId?: string, roleId?: string) => [
  'role-detail',
  userId,
  roleId,
]
export const getFarmGroupKey = (search: string) => ['farmGroup', search]

export const getDevicesKey = (farmId?: string, pondId?: string) => ['devices', farmId, pondId]
export const getOperationStatusKey = (
  farmId?: string,
  pondId?: string,
  deviceId?: string,
  operationId?: string
) => ['devices', farmId, pondId, deviceId, operationId]
export const getFeedingTrayKey = (farmId?: string, pondId?: string, deviceId?: string) => [
  'feedingTray',
  farmId,
  pondId,
  deviceId,
]

export const getFeedingTrayLogsKey = (
  farmId?: string,
  pondId?: string,
  deviceId?: string,
  date?: Date | undefined
) => ['feedingTrayLogs', farmId, pondId, deviceId, date]

export const getAutoFeedKey = (farmId?: string, pondId?: string, deviceId?: string) => [
  'autoFeed',
  farmId,
  pondId,
  deviceId,
]

export const getAutoFeedLogsKey = (
  farmId?: string,
  pondId?: string,
  deviceId?: string,
  date?: Date | undefined
) => ['autoFeedLogs', farmId, pondId, deviceId, date]

export const getShrimpTransferKey = (cycleId: string) => ['shrimpTransfer', cycleId]

export const getLatestCostPerKgKey = (cycleId: string) => [
  'shrimpTransfer',
  'latest-cost-per-kg',
  cycleId,
]

export const getTransferRecentSizeKey = (cycleId: string, date?: string) => [
  'shrimpTransfer',
  'recent-size',
  cycleId,
  date,
]

export const getPartialsKey = {
  all: () => ['partials'],
  list: (cycleId: string) => [...getPartialsKey.all(), 'list', cycleId],
}

export const getShrimpTopupKey = (cycleId: string, date: Date | undefined) => [
  'shrimpTopup',
  cycleId,
  date,
]

export const getShrimpTopupKeyById = (cycleId: string | undefined, shrimpTopupId: string) => [
  'shrimpTopupId',
  cycleId,
  shrimpTopupId,
]

export const getShrimpTopupSummary = (cycleId: string) => ['shrimpTopupSummary', cycleId]

export const getIotKeys = {
  all: () => ['iot-devices'],
  details: (deviceId: string) => [...getIotKeys.all(), 'details', deviceId],
  sensorHistory: (deviceId: string, sensor: string, params: Record<string, unknown>) => [
    ...getIotKeys.all(),
    deviceId,
    'sensor-history',
    sensor,
    params,
  ],
  thresholdRangeStatus: (deviceId: string) => [
    ...getIotKeys.all(),
    deviceId,
    'threshold-range-status',
  ],
}

export const getPondOldestIotDeviceKey = (farmId: string, pondId: string) => [
  'pond-oldest-iot-device',
  farmId,
  pondId,
]

export const CREDIT_WALLET_PROFILE_KEY = ['credit-wallet-profile']
export const CREDIT_WALLET_TRANSACTIONS_KEY = ['credit-wallet-transactions']
export const CREDIT_PACKAGES_KEY = ['credit-packages']
export const CREDIT_ORDERS_KEY = ['credit-orders']
export const CREDIT_ORDERS_COUNT_KEY = ['credit-orders-count']

export const getCreditFeatureCostKey = (featureCode: string) => ['credit-feature-cost', featureCode]

export const getFeatureConfigKey = (key: string) => ['feature-config', key]

export const INVENTORY_SETTINGS_KEY = ['inventory-settings']

export const ORG_DASHBOARD_FARMS_KEY = ['org-dashboard-farms']

export const getOrgPondsStatusKey = (farmIds: string[]) => [
  'org-ponds-status',
  ...[...farmIds].sort(),
]

export const getOrgPondsMonitoringKey = (farmIds: string[]) => [
  'org-ponds-monitoring',
  ...[...farmIds].sort(),
]

export const getOrgYieldBreedsKey = (farmIds: string[]) => [
  'org-yield-breeds',
  ...[...farmIds].sort(),
]

export const getOrgYieldSizesCurrentKey = (farmIds: string[], breedId?: number) => [
  'org-yield-sizes-current',
  ...[...farmIds].sort(),
  breedId ?? 'all',
]

export const getOrgYieldSizesEstimateKey = (farmIds: string[], breedId?: number) => [
  'org-yield-sizes-estimate',
  ...[...farmIds].sort(),
  breedId ?? 'all',
]

export const getOrgYieldSizePondsKey = (params: {
  farmIds: string[]
  breedId?: number
  dayOffset: number
  minSize?: number | null
  maxSize?: number | null
}) => [
  'org-yield-size-ponds',
  ...[...params.farmIds].sort(),
  params.breedId ?? 'all',
  params.dayOffset,
  params.minSize ?? 'none',
  params.maxSize ?? 'none',
]

export const getOrgYieldHarvestKey = (params: {
  farmIds: string[]
  breedId?: number
  minSize: number
  maxSize: number
  withinDays: number
}) => [
  'org-yield-harvest',
  ...[...params.farmIds].sort(),
  params.breedId ?? 'all',
  params.minSize,
  params.maxSize,
  params.withinDays,
]

export const getOrgDashboardFinanceKey = (farmIds: string[], displayMonth: number) => [
  'org-dashboard-finance',
  ...[...farmIds].sort(),
  displayMonth,
]

export const ORG_DASHBOARD_SECTION_SETTINGS_KEY = ['org-dashboard-section-settings']

export const getActiveAnnouncementsKey = () => ['active-announcements']

export const getNotificationUnreadCountKey = () => ['notification-unread-count']
export const getNotificationsKey = (params?: Record<string, any>) => ['notifications', params]
export const getNotificationsSettingsKey = (params?: Record<string, any>) => [
  'notifications-settings',
  params,
]
export const getNotificationsSettingsByModuleKey = (params?: Record<string, any>) => [
  'notifications-settings-by-module',
  params,
]
export const getIotDeviceNotificationSettingKey = (deviceId: string) => [
  'iot-device-notification-setting',
  deviceId,
]

// pond comparison
export const getPondComparisonSearchHistoryKey = () => ['pond-comparison-search-history']

export const getPondComparisonFoodKey = (cycleIds: string[]) => [
  'pond-comparison',
  'food',
  cycleIds,
]

export const getPondComparisonFoodStandardKey = (cycleIds: string[]) => [
  'pond-comparison',
  'food-standard',
  cycleIds,
]

export const getPondComparisonGrowthKey = (cycleIds: string[]) => [
  'pond-comparison',
  'growth',
  cycleIds,
]

export const getPondComparisonGrowthStandardKey = (cycleIds: string[]) => [
  'pond-comparison',
  'growth-standard',
  cycleIds,
]

export const getPondComparisonDOKey = (cycleIds: string[]) => ['pond-comparison', 'do', cycleIds]

export const getPondComparisonPHKey = (cycleIds: string[]) => ['pond-comparison', 'ph', cycleIds]

export const getPondComparisonTableKey = (cycleIds: string[]) => [
  'pond-comparison',
  'table',
  cycleIds,
]

export const getPondNamesKey = (farmId: string) => ['pond-names', farmId]
export const getFoodTodayKey = {
  all: () => ['food-today'],
  details: (farmId: string, pondId: string, cycleId: string) => [
    ...getFoodTodayKey.all(),
    farmId,
    pondId,
    cycleId,
  ],
}

export const getListProductByFoodKey = (farmId: string, pondId: string, cycleId: string) => [
  'list-product-by-food',
  farmId,
  pondId,
  cycleId,
]

export const getListProductByMedicineKey = {
  all: () => ['list-product-by-medicine'],
  list: (farmId: string, pondId: string, cycleId: string) => [
    ...getListProductByMedicineKey.all(),
    farmId,
    pondId,
    cycleId,
  ],
}

export const getListNaturalProductByFoodKey = (farmId: string, pondId: string, cycleId: string) => [
  'list-natural-product-by-food',
  farmId,
  pondId,
  cycleId,
]

export const getCostTransactionsHistoryKey = {
  all: () => ['cost-transactions-history'],
  list: (cycleId: string, params: Array<string | number>) => [
    ...getCostTransactionsHistoryKey.all(),
    cycleId,
    ...params,
  ],
}
export const getCostTransactionsHistoryInfiniteKey = {
  all: () => ['history-infinite'],
  list: ({
    cycleId,
    startDate,
    endDate,
  }: {
    cycleId: string
    startDate?: string
    endDate?: string
  }) => [...getCostTransactionsHistoryInfiniteKey.all(), cycleId, startDate, endDate],
}

export const getCostTransactionChartKey = {
  all: () => ['cost-transaction-chart'],
  stack: (cycleId: string, params: Array<string | number>) => [
    ...getCostTransactionChartKey.all(),
    'stack',
    cycleId,
    ...params,
  ],
  pie: (cycleId: string, categoryId: string) => [
    ...getCostTransactionChartKey.all(),
    'pie',
    cycleId,
    categoryId,
  ],
  line: (
    cycleId: string,
    params: { startDate?: string; endDate?: string; costPerUnit?: string }
  ) => [...getCostTransactionChartKey.all(), 'line', cycleId, params],
}

export const getCostTransactionCategoryKey = {
  all: () => ['cost-transaction-category-list'],
  list: (cycleId: string) => [...getCostTransactionCategoryKey.all(), cycleId],
}
export const getCostCategoryListKey = {
  all: () => ['cost-category-list'],
  list: (cycleId: string) => [...getCostCategoryListKey.all(), cycleId],
}
export const getCostTransactionGroupKey = {
  all: () => ['cost-transaction-group'],
  list: (cycleId: string) => [...getCostTransactionGroupKey.all(), cycleId],
}
export const getCostTransactionByIdKey = {
  all: () => ['cost-transaction-by-id'],
  detail: (cycleId: string, transactionId: string) => [
    ...getCostTransactionByIdKey.all(),
    cycleId,
    transactionId,
  ],
}
export const getCostTransactionLineChartKey = {
  all: () => ['cost-transaction-line-chart'],
  list: (
    cycleId: string,
    params: {
      startDate?: string
      endDate?: string
      costPerUnit?: string
    }
  ) => [...getCostTransactionLineChartKey.all(), cycleId, params],
}
export const getCostTransactionStackChartKey = {
  all: () => ['cost-transaction-stack-chart'],
  details: (cycleId: string, params: Array<string | number>) => [
    ...getCostTransactionStackChartKey.all(),
    cycleId,
    ...params,
  ],
}
export const getCostTransactionPieChartKey = {
  all: () => ['cost-transaction-pie-chart'],
  details: (cycleId: string, category_id: string) => [
    ...getCostTransactionPieChartKey.all(),
    cycleId,
    category_id,
  ],
}

// policy documents (terms & privacy consent)
export const POLICY_CONSENT_STATUS_KEY = ['policy-consent-status']
export const ACTIVE_POLICY_DOCUMENTS_KEY = ['active-policy-documents']
